import { retrieveObject } from '@/utils';

// modules for donation
const requireContext = require.context('./stores/modules', false, /.*\.js$/);

export default retrieveObject(requireContext);